import { toast } from "react-toastify";
import getAxiosError from "../../../app/api/axiosError";
import { axiosRequests } from "../../../app/api/axiosRequest";
import {
  FILES_FOLDER_LIST_URL,
  FILE_UPLOAD_URL,
  FILE_DOWNLOAD_URL,
} from "../constants";

export const fetchAllSftpData = async (dir: string): Promise<any> => {
  const url = FILES_FOLDER_LIST_URL; // Base URL
  const params = { remoteDirectory: dir }; // Query parameter
  try {
    const response = await axiosRequests.getWithQueryParam<any>(url, {
      params,
    });
    return response;
  } catch (error) {
    const appError = getAxiosError(error);
    toast.error(appError.errorMessage, { toastId: `failedToGetTheFileFolderDataFromSFTPServer` });
    
  }
};

export const deleteFile = async (dir: string, file: string): Promise<void> => {
  const url = `${FILES_FOLDER_LIST_URL}?remoteDirectory=${dir}&filename=${file}`;

  try {
    const response = await axiosRequests.delete<void>(url);
    console.log("File deleted successfully");
  } catch (error) {
    const appError = getAxiosError(error);
        toast.error(appError.errorMessage, { toastId: `issueOnFileUpload` });
  }
};

export const uploadFile = async (
  formData: FormData,
  directory: string
): Promise<void> => {
  const url = `${FILE_UPLOAD_URL}?directory=${directory}`;

  try {
    await axiosRequests.post<void>(url, formData);
    console.log("File uploaded successfully");
  } catch (error) {
    const appError = getAxiosError(error);
    toast.error(appError.errorMessage, { toastId: `errorOnFileUpload` });
  }
};
export const downloadFile = async (
  dir: string,
  file: string
): Promise<any> => {
  const url = `${FILE_DOWNLOAD_URL}${dir}/${file}`;

  try {
    const response = await axiosRequests.getWithQueryParamAndReturnBlob<void>(
      url,
      {
        headers: {
          "Content-Type": "application/octet-stream",
        },
        responseType: "blob",
      }
    );
    return response.data;
  } catch (error) {
    const appError = getAxiosError(error);
        toast.error(appError.errorMessage, { toastId: `errorOnFileDownload` });
  }
};
